const LOCK_PREFIX = 'biliup.agent.thread-run.'
const FALLBACK_LEASE_MS = 30 * 60 * 1000

type LockManagerLike = {
  request: <T>(name: string, options: { ifAvailable: true }, callback: (lock: unknown | null) => Promise<T>) => Promise<T>
}

function fallbackLockKey(name: string) {
  return `${LOCK_PREFIX}${encodeURIComponent(name)}`
}

/** 在同一浏览器的多个标签页之间串行化同一 Agent 线程。 */
export async function withThreadRunLock(name: string, owner: string, action: () => Promise<void>): Promise<boolean> {
  const lockManager = (navigator as Navigator & { locks?: LockManagerLike }).locks
  if (lockManager?.request) {
    let acquired = false
    await lockManager.request(`${LOCK_PREFIX}${name}`, { ifAvailable: true }, async lock => {
      if (!lock) return
      acquired = true
      await action()
    })
    return acquired
  }

  const key = fallbackLockKey(name)
  const now = Date.now()
  try {
    const current = JSON.parse(localStorage.getItem(key) || 'null') as { owner?: string; expiresAt?: number } | null
    if (current?.owner && Number(current.expiresAt) > now) return false
    localStorage.setItem(key, JSON.stringify({ owner, expiresAt: now + FALLBACK_LEASE_MS }))
    const claimed = JSON.parse(localStorage.getItem(key) || 'null') as { owner?: string } | null
    if (claimed?.owner !== owner) return false
    try {
      await action()
      return true
    } finally {
      const latest = JSON.parse(localStorage.getItem(key) || 'null') as { owner?: string } | null
      if (latest?.owner === owner) localStorage.removeItem(key)
    }
  } catch {
    // localStorage 不可用时仍由服务端线程锁提供最终并发保护。
    await action()
    return true
  }
}
